export const COOKIES_ACCEPTED = 'cookiesAccepted';
export const MARKETING_ACCEPTED = 'marketingAccepted';
